





























































































































































































































import Vue from "vue";
import { Component, Prop, Emit, PropSync } from "vue-property-decorator";
import Selector from "../../shared/Selector.vue";
import Accordion from "../../shared/Accordion.vue";
import { TranslatedCountryDTO } from "../../../model/component.model";
import { AddressDTO } from "../../../model/data.model";
import { isItaly } from "./../../../services/Helpers";

@Component({
  components: {
    MbeSelector: Selector,
    MbeAccordion: Accordion
  }
})
export default class ContactAddressDetail extends Vue {
  @Prop() value: AddressDTO;
  @PropSync("res") resProp: boolean;
  @PropSync("mmr") mmrProp: boolean;
  @PropSync("ltz") ltzProp: boolean;

  isItaly = isItaly();

  @Prop({ default: false }) disableSaveButton: boolean;
  @Prop({ default: false }) disableCancelButton: boolean;
  @Prop({ default: false }) disableDeleteButton: boolean;
  @Prop() typeAddress: number;

  @Prop({ required: true }) validations: any;

  @Emit() save() {}
  @Emit() cancel() {}
  @Emit() remove() {}
  @Prop() molUserLogged: string;
  @Prop() molAddress: string;

  @Prop() countries: TranslatedCountryDTO[];

  created() {
    if (!this.value.state || this.value.state === "") {
      if (this.value.province && this.value.province !== "") {
        this.value.state = this.value.province;
      }
    }
    if (!this.value.province || this.value.province === "") {
      if (this.value.state && this.value.state !== "") {
        this.value.province = this.value.state;
      }
    }
  }

  get country() {
    let country;
    if (this.value.countryId === undefined || this.value.countryId === "") {
      if (this.countries[0] !== undefined) {
        const countryToSelect = this.countries.find(
          c =>
            c.id === this.$store.getters["customer/storeAddresses"][0].countryId
        );
        this.$emit("input", {
          ...this.value,
          countryId: countryToSelect.id,
          countryName: countryToSelect.name
        });
      }
    } else {
      country = {
        id: this.value.countryId,
        name: this.value.countryName,
        translatedName: this.$t("country_" + this.$t(this.value.countryId))
      };
    }
    return country;
  }

  set country(country: any) {
    if (
      country.id !== this.value.countryId &&
      country.name != this.value.countryName
    ) {
      const changedAddress: AddressDTO = { ...this.value };
      changedAddress.countryId = country.id;
      changedAddress.countryName = country.name;
      this.$emit("input", changedAddress);
    }
  }

  get province() {
    return this.value.province && this.value.province !== ""
      ? this.value.province
      : this.value.state;
  }

  set province(val: any) {
    this.value.province =
      this.value.countryName === "Italy" ? val.toUpperCase() : val;
    this.value.state =
      this.value.countryName === "Italy" ? val.toUpperCase() : val;
  }
}
